module.exports = __webpack_public_path__ + "img/logo-darkfans-black.a486a7fa.svg";